import { URLS } from "utils/constants";
import { Navigate } from "react-router-dom";

// Components
import Orders from "pages/resto/orders";
import POSPage from "pages/POS/POSpage";
import POS_History from "pages/POS/History/POS_History";
import POS_Products from "pages/POS/Products/POS_Products";
import POS_Stock from "pages/POS/Stock/POS_Stock";
import SupplierPage from "pages/POS/Supplier/SupplierPage";
import PermissionMiddleware from "middleware/PermissionMiddleware";
import CashierHistoryPage from "pages/POS/CashierHistory/CashierHistoryPage";
import DailyReportPOS from "pages/POS/Report/DailyReportPOS";

// Contexts Providers
import { CategoryProvider } from "pages/POS/context/CategoryContext";
import { SupplierProvider } from "pages/POS/Supplier/SupplierContext";
import { MenuProvider } from "pages/POS/Products/MenuContext";
import { TransactionProvider } from "pages/POS/History/TransactionContext";
import { CashierSessionProvider } from "pages/POS/context/CasierSessionContext";
import { CashierHistoryProvider } from "pages/POS/CashierHistory/CasierHistoryContext";
import { DailyTransactionProvider } from "pages/POS/Report/DailyTransactionContext";
import { MenuActiveProvider } from "pages/POS/Products/MenuActiveContext";

export const restoRoutes = [
  {
    path: URLS.v1.ORDERS,
    element: <Orders />,
  },
  {
    path: URLS.v1.POS,
    element: (
      <PermissionMiddleware
        allowedRoles={["superadmin", "admin", "resto"]}
        fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />} // Jika akses tidak diizinkan, arahkan ke halaman Unauthorized gunakan URLS.v1.NOTAUTHORIZED}
      >
        <CashierSessionProvider>
          <CategoryProvider>
            <MenuActiveProvider>
              <POSPage />
            </MenuActiveProvider>
          </CategoryProvider>
        </CashierSessionProvider>
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.TRANSACTIONS_HISTORY,
    element: (
      <DailyTransactionProvider>
        <TransactionProvider>
          <POS_History />
        </TransactionProvider>
      </DailyTransactionProvider>
    ),
  },
  {
    path: URLS.v1.PRODUCT_RESTO,
    element: (
      <SupplierProvider>
        <MenuProvider>
          <CategoryProvider>
            <POS_Products />
          </CategoryProvider>
        </MenuProvider>
      </SupplierProvider>
    ),
  },
  {
    path: URLS.v1.STOCK_RESTO,
    element: <POS_Stock />,
  },
  {
    path: URLS.v1.SUPPLIER,
    element: (
      <SupplierProvider>
        <SupplierPage />
      </SupplierProvider>
    ),
  },
  {
    path: URLS.v1.CASHIERHISTORY,
    element: (
      <CashierHistoryProvider>
        <CashierHistoryPage />
      </CashierHistoryProvider>
    ),
  },
  {
    path: URLS.v1.DAILYREPORTRESTO,
    element: (
      <DailyTransactionProvider>
        <DailyReportPOS />
      </DailyTransactionProvider>
    ),
  },
];
